module.exports = __webpack_public_path__ + "img/library-capsule.1ef61d07.svg";